/**
 * @type {StoreDescriptor}
 */
export default {
  name: 'files',
  keyPath: 'url',
  indexes: [['date', 'date']],
}
